import axios from "axios";

export default {
  data() {
    return {
      apiUrl: this.mashupsEditorAppbarConfig.api,
      tenantId: this.realm,
      // mashup: {},
      urlPath: "",
      mashupId: "",
      mashupVersion: "",
    };
  },
  mounted() {
    this.urlPath = window.location.pathname;
    this.mashupId = this.urlPath.split("draw/").pop().split("/v")[0];
    this.mashupVersion = this.urlPath.split("v/").pop().split("/edit")[0];
  },
  methods: {
    updateMashup() {
      axios
        .put(
          this.apiUrl + "/" + this.tenantId + "/projects/" + this.mashupId,
          this.mashupProp,
          this.opts,
        )
        .then(() => {
          // this.mashupProp = response.data;
          document.dispatchEvent(
            new CustomEvent("confirmation-dialog", {
              detail: {
                storage: true,
              },
            }),
          );
          document.dispatchEvent(
            new CustomEvent("refresh-mashup-list", {
              detail: {
                storage: true,
              },
            }),
          );
        })
        .catch((err) => {
          this.setError(err, false);
        });
    },
  },
};
